import { motion } from 'framer-motion'
import StarRating from '../../components/StarRating'

const testimonials = [
  {
    name: 'Francis kalarikkal',
    location: 'Sarah M., United Kingdom',
    date: '10th feb, 2026',
    quote:
      'Our transfer from Salzburg Airport was smooth and stress-free. The driver was punctual, professional, and very friendly. Highly recommended!',
    avatar: '/assets/images/testimonial-avatar.png',
  },
  {
    name: 'Emma & David',
    location: 'Australia',
    date: '10th feb, 2026',
    quote:
      'Excellent service from start to finish. Booking was easy, communication was great, and the driver arrived exactly on time.',
    avatar: '/assets/images/testimonial-avatar.png',
  },
  {
    name: 'Michael T',
    location: 'Germany',
    date: '10th feb, 2026',
    quote:
      'The best airport transfer service we used during our trip to Austria. Clean vehicle, professional driver, and fixed pricing with no surprises.',
    avatar: '/assets/images/testimonial-avatar.png',
  },
] as const

type TestimonialCardProps = {
  name: string
  location: string
  date: string
  quote: string
  avatar: string
}

function TestimonialCard({
  name,
  location,
  date,
  quote,
  avatar,
}: TestimonialCardProps) {
  return (
   <motion.article 
      variants={{
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
      }}
      className="flex w-full shrink-0 flex-col rounded-[19px] bg-white p-6 shadow-[2px_2px_7.3px_0px_rgba(138,126,126,0.25)] lg:w-[401px]"
    >
      <StarRating className="mb-4" />
      <p className="font-host text-base leading-[1.37] text-black">{quote}</p>
    <div className="mt-auto pt-6">
  <div className="flex min-h-[57px] items-center gap-4">
    <div className="h-[57px] w-[57px] shrink-0 overflow-hidden rounded-full bg-white">
      <img
        src={avatar}
        alt={name}
        className="h-full w-full object-cover"
      />
    </div>

    <div className="min-w-0">
      <p className="font-host text-xl font-medium text-black">
        {name}
      </p>

      <p className="font-host text-sm text-[#636363]">
        {location}
      </p>
    </div>
  </div>

  <p className="mt-2 text-right font-host text-[15px] font-medium tracking-[-0.022em] text-black">
    {date}
  </p>
</div>
    </motion.article>
  )
}

export default function Testimonials() {
  return (
    <section className="mx-auto max-w-page px-4 py-16 lg:px-[92px] lg:py-20 overflow-hidden">
      <motion.div 
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-100px" }}
        variants={{
          visible: {
            transition: {
              staggerChildren: 0.1,
            },
          },
        }}
      >
        <motion.h2 
          variants={{
            hidden: { opacity: 0, y: 20 },
            visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
          }}
          className="mb-8 max-w-[552px] font-host text-[28px] font-medium leading-[1.5] tracking-[-0.02em] text-black"
        >
          Thousands of Travelers Trust Salzburg Cab. Journeys They&apos;ll Always Remember.
        </motion.h2>
        <div className="flex flex-col gap-6 md:flex-row md:overflow-x-auto md:pb-4 scrollbar-hide lg:gap-[26px]">
          {testimonials.map((item) => (
            <TestimonialCard key={item.name} {...item} />
          ))}
        </div>
      </motion.div>
    </section>
  )
}
